// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetSimpleObjectsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSimpleObjectsQuery = {
  customObjectDefinitions: { customObjectDefinitions?: Array<{ name?: string | null; uid: string } | null> | null };
};

export const GetSimpleObjectsDocument = gql`
    query GetSimpleObjects {
  customObjectDefinitions {
    customObjectDefinitions {
      name
      uid
    }
  }
}
    ` as unknown as DocumentNode<GetSimpleObjectsQuery, GetSimpleObjectsQueryVariables>;
